<template>
  <div class="feed-item-details">
    <span v-if="showName && child" class="user-name">
      {{ child ? child.name : $t("userRemoved") }} &middot;
    </span>

    <span v-if="date && todayItem" class="date">
      {{ date | timeAgo }}
    </span>

    <span v-if="date && lastWeekItem" class="date">
      {{ date | timeAgo | capitalize }} {{ $t("at") }} {{ date | localTime }} {{ $t("timeClarifier") }}
    </span>

    <span v-if="date && olderThanWeekItem" class="date">
      {{ date | localDate }}
    </span>

    <span v-if="device && showDevice" class="device">
      &middot; {{ device.name }}
    </span>
  </div>
</template>

<script>
  import { dateDiffFromNow } from '@/services/intl'

  export default {
    props: {
      item: {
        required: true,
        type: Object
      },

      showName: {
        type: Boolean,
        required: false,
        default: true
      },

      showDevice: {
        type: Boolean,
        required: false,
        default: true
      }
    },

    methods: {
      dateDiffFromNow
    },

    computed: {
      date() {
        return this.item.create_timestamp
      },

      child() {
        return this.getChildById(this.item.user_id)
      },

      device() {
        return this.child
          ?this.child.devices.find(device => device.id === this.item.device_id)
          : null
      },

      itemDateDiffFromNow() {
        return dateDiffFromNow(this.date, 'day')
      },

      todayItem() {
        return this.itemDateDiffFromNow < 1
      },

      lastWeekItem() {
        return this.itemDateDiffFromNow >= 1 && this.itemDateDiffFromNow <= 7
      },

      olderThanWeekItem() {
        return this.itemDateDiffFromNow > 7
      },

      ...mapGetters('children', {
        getChildById: 'getById'
      })
    }
  }
</script>

<style lang="scss" scoped>
  .user-name {
    word-wrap: break-word;
  }
</style>
